<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
<div class="py-5 w-full">
    <!-- -------------------------------------------header tab section--------------------------  -->
    <section
      class="flex flex-col lg:flex-row lg:justify-between lg:items-center"
    >
      <div class="flex ml-auto mb-8">
        <tab-buttons
          label="account"
          :callback="(e) => handlePageChange(e)"
          :currentValue="currentComponent"
        />
        <div v-if="userDetails && userDetails.role !== 'USER'">
        <tab-buttons
            label="products"
            :callback="(e) => handlePageChange(e)"
            :currentValue="currentComponent"
        />
        </div>
      </div>
    </section>

    <!-- segment selection section -->
    <!-- ---------------------------------------------------overview ------------------------------------->
    <section v-if="currentComponent == 'account'" class="w-full">
      <account />
    </section>
    <!-- ---------------------------------------------------activity ------------------------------------->
    <section v-if="currentComponent == 'products'">
      <products />
    </section>
  </div>
</template>

<script>
import TabButtons from '../../components/Audience/TabButtons.vue';
import Account from '../../components/Configure/Account.vue';
import Products from '../../components/Configure/Products.vue';

export default {
  name: 'configure',
  layout: 'admin',
  components: { TabButtons, Account, Products },
  data() {
    return {
      currentComponent: 'account',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userDetails() {
      return this.$store.state?.userDetails;
    },
  },
  mounted() {
    if (!this.userDetails) {
      this.$store.dispatch('getMyDetails', {});
    }
  },
  methods: {
    handlePageChange(e) {
      this.currentComponent = e;
    },
  },
};
</script>
